import React from 'react'
import { Box, Card, Icon, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useState } from 'react'
import EditOverlay from './editOverlay'

const InactiveSection = ({
  sectionName,
  sectionNumber,
  sectionColor,
  formType,
  formLoading,
  sectTitle,
  sectDesc,
  sx,

  ...rest
}) => {
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('sm'))
  const [editOverlay, setEditOverlay] = useState(false)

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="flex-end"
      position="relative"
      onMouseEnter={() => setEditOverlay(true)}
      onMouseLeave={() => setEditOverlay(false)}
    >
      {editOverlay && <EditOverlay />}
      <Card
        sx={{
          width: '100%',
          height: 'auto',
          paddingTop: '16px',
          paddingBottom: '20px',
          boxShadow: '0px 0px 10px lightgray',
          borderRadius: '4.5px',
          ...sx,
        }}
      >
        <Box
          sx={{
            borderBottom: '1px solid',
            borderBottomColor: 'gray-line.main',
            padding: '0px 25px 16px',
          }}
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          {sectionName === 'formHeader' ? (
            <Typography variant="h4" color="alternate.main" fontWeight={600}>
              {formType} Form{' '}
            </Typography>
          ) : (
            <Typography variant="h4" color="alternate.main" fontWeight={600}>
              Section {sectionNumber ? sectionNumber : null}
            </Typography>
          )}
        </Box>
        <Box sx={{ padding: '20px 25px 0px' }} display="flex" flexDirection="column" gap={2.5}>
          <Typography
            variant="h4"
            // fontWeight={600}
            // color="error.main"
            color={sectTitle === '' ? 'error.main' : 'dark-text.main'}
            sx={{ whiteSpace: 'pre-line' }}
          >
            {/* {sectTitle === "" ?
              <Icon
                sx={{
                  color: 'error.main',
                  marginRight: '10px',
                  verticalAlign: 'bottom',
                }}
              >
                warning_icon
              </Icon>
              :
              null
            } */}
            {formLoading
              ? 'Loading...'
              : sectTitle !== ''
              ? sectTitle
              : sectionName === 'formHeader'
              ? 'Form title cannot be empty'
              : 'Section title cannot be empty'}
          </Typography>
          {sectDesc && (
            <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
              {sectDesc}
            </Typography>
          )}
        </Box>
      </Card>
    </Box>
  )
}

export default InactiveSection
